import React, { useMemo } from 'react';
import { IconButton, Stack } from '@mui/material';
import DocDetailsControlsConfig from './DocDetailsControlsConfig';
import Icon from '@mdi/react';
import { vars } from '../../../Theme';
import { IDocumentDetailsViewProps } from '../../Views/DocumentDetailsView/DocumentDetailsViewContent';

/**
 * Component that shows Controls for the document details.
 */
export default (props: IDocumentDetailsControlsProps) => {
    /**
     * Defines controls object.
     */
    const controlsObject = useMemo(() => DocDetailsControlsConfig(props), [props]);

    return (
        <Stack direction='row'>
            {Object.keys(controlsObject).map(controlKey => {
                const _control = controlsObject[controlKey];
                if (_control.component) {
                    return _control.component;
                }
                return (
                    <IconButton
                        disabled={_control.disabled}
                        key={controlKey}
                        sx={{ color: vars.font }}
                        onClick={_control.onClick}
                        loading={_control.loading}
                    >
                        <Icon path={_control.icon} size={1} />
                    </IconButton>
                );
            })}
        </Stack>
    );
};

/**
 * Interface that describes DocumentDetailsControl's props.
 */
export interface IDocumentDetailsControlsProps
    extends Omit<IDocumentDetailsViewProps, 'replicaId'> {
    /** Document's type. */
    docType: string;

    /** Document's type key for template creation. */
    docTypeKey: string;

    /** Document's idDocIndex. */
    universalId: string;

    /** Defines if the Dialog is expanded. */
    isExpanded: boolean;

    /** Defines if the Save btn disabled. */
    isSaveButtonDisabled: boolean;

    /** Defines if the Save btn loaded. */
    isSaveButtonLoaded: boolean;

    /** Defines if the Edit btn disabled. */
    isEditButtonDisabled: boolean;

    /** Changes mode. */
    handleChangeMode: () => void;

    /**  Closes Dialog. */
    handleCloseDialog: () => void;

    /**  Expandes Dialog and return back. */
    handleExpandDialog: () => void;

    /** Submit Formdesigner's form and save document's data. */
    handleClickSaveBtn: () => void;
}
